import prism from 'prismjs'

export const highlightCode = (str: string, lang: string) => {
  const language = prism.languages[lang]
  if (language) {
    try {
      return prism.highlight(str, language, lang)
    } catch (err) {}
  }

  return '' // use external default escaping
}

export const MarkdownRendererOptions = {
  preset: 'full',
  html: false,
  xhtmlOut: false,
  breaks: false,
  langPrefix: 'language-',
  linkify: false,
  typographer: true,
  highlight: highlightCode
}
